module.exports = __webpack_public_path__ + "static/img/lc1-5.77eeb77.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/lc1-5.png
// module id = 837
// module chunks = 0